// extracted by mini-css-extract-plugin
export default {"loginFormContent":"UnAuthorizedContent_loginFormContent__0Dj46"};